export default __webpack_public_path__ + "static/media/Staubli.83b0d603.png";